export default __webpack_public_path__ + "static/media/022-washing machine.5c23b73c.svg";